import { cn } from "utils";

export const ShimmerEffect = ({ className }) => (
  <div className={cn("animate-pulse bg-gray-200 rounded-lg", className)} />
);
